"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTapeBuilderRecordUI = exports.isTapeBuilderRecordDB = exports.isTapeBuilderRecordUI = exports.checkArtifact = exports.isTapeBuilderTask = exports.isTapeBuilderPreFilterTask = exports.isTapeBuilderSanitizeTask = exports.isTapeBuilderXlsx2CsvTask = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const dbNodes = __importStar(require("./dbNodes/dbNodes"));
const OperationNodes = __importStar(require("./uiNodes/operations"));
const tasks_1 = require("./uiNodes/tasks");
const isTapeBuilderXlsx2CsvTask = (obj) => {
    return OperationNodes.Xlsx2Csv.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderXlsx2CsvTask = isTapeBuilderXlsx2CsvTask;
const isTapeBuilderSanitizeTask = (obj) => {
    return OperationNodes.Sanitize.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderSanitizeTask = isTapeBuilderSanitizeTask;
const isTapeBuilderPreFilterTask = (obj) => {
    return OperationNodes.PreFilter.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderPreFilterTask = isTapeBuilderPreFilterTask;
const isTapeBuilderTask = (obj) => {
    // make a light check first to avoid heavy schema check
    if ('operation' in obj && typeof obj.operation === 'string') {
        return tasks_1.TapeBuilderTaskSchema.safeParse(obj).success;
    }
    return false;
};
exports.isTapeBuilderTask = isTapeBuilderTask;
const isArtifactType = (obj) => {
    return (typeof obj === 'string' && finley_types_1.DbTable.ArtifactTypeIterable.includes(obj));
};
const checkArtifact = ({ obj, artifactType, checkIntermediate, onError, }) => {
    switch (artifactType) {
        case dbNodes.assignedLoanTape.artifactType:
            return dbNodes.assignedLoanTape.typeGuard(obj, onError);
        case dbNodes.cashBalancesFeedContext.artifactType:
            return dbNodes.cashBalancesFeedContext.typeGuard(obj, onError);
        case dbNodes.cashResponseTape.artifactType:
            return dbNodes.cashResponseTape.typeGuard(obj, onError);
        case dbNodes.configTape.artifactType:
            return dbNodes.configTape.typeGuard(obj, onError);
        case dbNodes.dataLakeTape.artifactType:
            return dbNodes.dataLakeTape.typeGuard(obj, onError);
        case dbNodes.directInsertPortfolioCovenant.artifactType:
            return dbNodes.directInsertPortfolioCovenant.typeGuard(obj, onError);
        case dbNodes.directInsertPortfolioCovenants.artifactType:
            return dbNodes.directInsertPortfolioCovenants.typeGuard(obj, onError);
        case dbNodes.directInsertFinancialCovenants.artifactType:
            return dbNodes.directInsertFinancialCovenants.typeGuard(obj, onError);
        case dbNodes.forwardedTape.artifactType:
            return dbNodes.forwardedTape.typeGuard(obj, onError);
        case dbNodes.fundingApprovalReport.artifactType:
            return dbNodes.fundingApprovalReport.typeGuard(obj, onError);
        case dbNodes.fundingRequest.artifactType:
            return dbNodes.fundingRequest.typeGuard(obj, onError);
        case dbNodes.fundingVerificationReport.artifactType:
            return dbNodes.fundingVerificationReport.typeGuard(obj, onError);
        case dbNodes.generatedCashBalanceFeed.artifactType:
            return dbNodes.generatedCashBalanceFeed.typeGuard(obj, onError);
        case dbNodes.generatedCovenantLoanTape.artifactType:
            return dbNodes.generatedCovenantLoanTape.typeGuard(obj, onError);
        case dbNodes.generatedFinancialData.artifactType:
            return dbNodes.generatedFinancialData.typeGuard(obj, onError);
        case dbNodes.generatedLoanTape.artifactType:
            return dbNodes.generatedLoanTape.typeGuard(obj, onError);
        case dbNodes.generatedRepaymentTape.artifactType:
            return dbNodes.generatedRepaymentTape.typeGuard(obj, onError);
        case dbNodes.generatedSupplementalTape.artifactType:
            return dbNodes.generatedSupplementalTape.typeGuard(obj, onError);
        case dbNodes.finStatement.artifactType:
            return dbNodes.finStatement.typeGuard(obj, onError);
        case dbNodes.intermediateTape.artifactType:
            return dbNodes.intermediateTape.typeGuard(obj, onError);
        case dbNodes.internalRepaymentTape.artifactType:
            return dbNodes.internalRepaymentTape.typeGuard(obj, onError);
        case dbNodes.limitedPartnersTape.artifactType:
            return dbNodes.limitedPartnersTape.typeGuard(obj, onError);
        case dbNodes.manualBankAccountReport.artifactType:
            return dbNodes.manualBankAccountReport.typeGuard(obj, onError);
        case dbNodes.masterLoanTape.artifactType:
            return dbNodes.masterLoanTape.typeGuard(obj, onError);
        case dbNodes.orgProvidedInput.artifactType:
            return dbNodes.orgProvidedInput.typeGuard(obj, onError);
        case dbNodes.orgProvidedInputs.artifactType:
            return dbNodes.orgProvidedInputs.typeGuard(obj, onError);
        case dbNodes.rawCashBalanceFeed.artifactType:
            return dbNodes.rawCashBalanceFeed.typeGuard(obj, onError);
        case dbNodes.rawLoanTape.artifactType:
            return dbNodes.rawLoanTape.typeGuard(obj, onError);
        case dbNodes.rawReceivableDocumentation.artifactType:
            return dbNodes.rawReceivableDocumentation.typeGuard(obj, onError);
        case dbNodes.rawRepaymentTape.artifactType:
            return dbNodes.rawRepaymentTape.typeGuard(obj, onError);
        case dbNodes.rawSupplementalTape.artifactType:
            return dbNodes.rawSupplementalTape.typeGuard(obj, onError);
        case dbNodes.rawZipTape.artifactType:
            return dbNodes.rawZipTape.typeGuard(obj, onError);
        case dbNodes.receivableDocumentationVerificationReport.artifactType:
            return dbNodes.receivableDocumentationVerificationReport.typeGuard(obj, onError);
        case dbNodes.receivableInvoice.artifactType:
            return dbNodes.receivableInvoice.typeGuard(obj, onError);
        case dbNodes.receivableResponseTape.artifactType:
            return dbNodes.receivableResponseTape.typeGuard(obj, onError);
        case dbNodes.receivableResponseTapePreview.artifactType:
            return dbNodes.receivableResponseTapePreview.typeGuard(obj, onError);
        case dbNodes.userInputNeeded.artifactType:
            return dbNodes.userInputNeeded.typeGuard(obj, onError);
        case dbNodes.valleyBankIngest.artifactType:
            return dbNodes.valleyBankIngest.typeGuard(obj, onError);
        case dbNodes.valleyBankSlsCommitment.artifactType:
            return dbNodes.valleyBankSlsCommitment.typeGuard(obj, onError);
        case dbNodes.valleyBankSlsIngest.artifactType:
            return dbNodes.valleyBankSlsIngest.typeGuard(obj, onError);
        case dbNodes.waitForDataLakeTable.artifactType:
            return dbNodes.waitForDataLakeTable.typeGuard(obj, onError);
        case dbNodes.uploadToDatalake.artifactType:
            return dbNodes.uploadToDatalake.typeGuard(obj, onError);
        // special nodes where intermediate node config is different from dbConfig.
        case dbNodes.assignedRepaymentTape.artifactType:
            if (checkIntermediate) {
                return dbNodes.assignedRepaymentTape.typeGuardIntermediate(obj, onError);
            }
            return dbNodes.assignedRepaymentTape.typeGuard(obj, onError);
        case dbNodes.borrowingBaseReport.artifactType:
            if (checkIntermediate) {
                return dbNodes.borrowingBaseReport.typeGuardIntermediate(obj, onError);
            }
            return dbNodes.borrowingBaseReport.typeGuard(obj, onError);
        case dbNodes.directInsertBorrowingBaseReport.artifactType:
            if (checkIntermediate) {
                return dbNodes.directInsertBorrowingBaseReport.typeGuardIntermediate(obj, onError);
            }
            return dbNodes.directInsertBorrowingBaseReport.typeGuard(obj, onError);
        default:
            return (0, common_1.finleyAssertUnreachable)(artifactType);
    }
};
exports.checkArtifact = checkArtifact;
const isTapeBuilderRecordUI = (obj) => {
    // instead of running big union jsonschema, which can be very expensive
    // we are going to first find the type of node, and run a smaller schema
    // check.
    if (!('type' in obj)) {
        (0, common_1.debugLog)('isTapeBuilderRecordUI: no type in obj:', obj);
        return false;
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`isTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return false;
    }
    return (0, exports.checkArtifact)({ obj, artifactType, checkIntermediate: true });
};
exports.isTapeBuilderRecordUI = isTapeBuilderRecordUI;
const isTapeBuilderRecordDB = (obj) => {
    // instead of running big union jsonschema, which can be very expensive
    // we are going to first find the type of node, and run a smaller schema
    // check.
    if (!('type' in obj)) {
        (0, common_1.debugLog)('isTapeBuilderRecordDB: no type in obj:', obj);
        return false;
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`isTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return false;
    }
    return (0, exports.checkArtifact)({ obj, artifactType, checkIntermediate: false });
};
exports.isTapeBuilderRecordDB = isTapeBuilderRecordDB;
// This is not strictly a typeguard in the sense that it doesn't return a boolean.
const validateTapeBuilderRecordUI = (obj) => {
    if (!('type' in obj)) {
        (0, common_1.debugLog)('validateTapeBuilderRecordUI: no type in obj:', obj);
        return {
            isValid: false,
            errorMessages: ['validateTapeBuilderRecordUI: no type in obj:'],
        };
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`validateTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return {
            isValid: false,
            errorMessages: [
                `validateTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`,
            ],
        };
    }
    const errorMessages = [];
    const onError = (errors, instance) => {
        (0, common_1.debugLog)(`Error validating schema for ${artifactType}`, errors, instance);
        errors.forEach((err) => {
            errorMessages.push(err);
        });
    };
    const isValid = (0, exports.checkArtifact)({
        obj,
        artifactType,
        checkIntermediate: true,
        onError,
    });
    return {
        isValid,
        errorMessages,
    };
};
exports.validateTapeBuilderRecordUI = validateTapeBuilderRecordUI;
//# sourceMappingURL=typeguards.js.map